$(document).ready(function() {

	// naivgation logic
	var lastClicked = "";
	var currentClicked = "";

	$('.nav-trigger').on('click', function(event) {
		currentClicked = $(this).attr('data-trigger');

		//$(this).toggleClass('show');
		// closer acts for every overlay
		var closerActive = $(this).find('.open').is(':visible');

		// close element
		if ((lastClicked == currentClicked && $("nav." + currentClicked).hasClass('active')) || closerActive)  {
			$('body').removeClass('nav-content-active');
			$('nav.active').removeClass('active');
			return;
		}

		// open
		$('nav.active').removeClass('active');
		$('body').addClass('nav-content-active');
		$("nav." + currentClicked).addClass('active');

		
		lastClicked = currentClicked;
	});

	$('nav .close').on('click', function(event) {
		$('body').removeClass('nav-content-active');
		$('nav.active').removeClass('active');
	});

	// navigation main
	var nav = $('nav.main');

	nav.find('ul.main-nav > li').addClass('closed');

	nav.find('ul.main-nav > li.has-sub').on('click', function(event) {
		var navEl = $(this);

		if(!navEl.hasClass('active')) {
            event.preventDefault();
            nav.find('ul.main-nav > li').removeClass('active');
            nav.find('ul.main-nav > li').addClass('closed');

            navEl.addClass('active');
            navEl.removeClass('closed');
        }
	});

    // hamburger
    //nav.addClass('closed');

    nav.find('.nav-icon').on('click', function (event) {
        nav.toggleClass('closed');
        nav.toggleClass('open');
    });

    var lastScrollTop = 0;
	$(window).scroll(function () {
	    var scrollTop = $(this).scrollTop();

	    if (scrollTop > lastScrollTop) {
	        // down
	        if (scrollTop > 100) {
	        	nav.addClass('closed');
	        	nav.removeClass('open');
	        }
	    } else {
	        // up
	        if (scrollTop < 100) {
	        	nav.removeClass('closed');
	        	nav.addClass('open');
	        }
	    }


	    lastScrollTop = scrollTop;
	});
});


/** WEBPACK FOOTER **
 ** ./Frontend/js/modules/header/index.js
 **/